import { useQuery } from '@tanstack/react-query';
import { useAuthtoken } from 'stores/useAuthStore';
import request, { getDefaultRequestOptions } from 'utils/request';
import type { ApiRespBody } from 'types/api';
import type { TimesheetErp } from 'containers/Organizations/organizations.types';

export const TIMESHEET_ERPS_QUERY_KEY = ['timesheetErps'] as const;

async function fetchTimesheetErps(
  authToken: string,
  signal?: AbortSignal
): Promise<TimesheetErp[]> {
  const result = await request<ApiRespBody<TimesheetErp[]>>(
    '/api/timesheets/erps',
    getDefaultRequestOptions('GET', authToken, undefined, signal)
  );
  if (!result?.success || !result.data) throw new Error('Could not load timesheet ERPs');
  return result.data;
}

function useTimesheetErpsQuery() {
  const authToken = useAuthtoken();
  return useQuery({
    queryKey: TIMESHEET_ERPS_QUERY_KEY,
    queryFn: ({ signal }) => fetchTimesheetErps(authToken ?? '', signal),
    enabled: !!authToken,
    staleTime: Infinity,
  });
}

/** ERP selections timesheets can be enabled for; undefined until loaded. */
export function useTimesheetErps(): TimesheetErp[] | undefined {
  return useTimesheetErpsQuery().data;
}

/** True while the ERP list's first fetch is in flight. */
export function useTimesheetErpsLoading(): boolean {
  return useTimesheetErpsQuery().isLoading;
}
